import { render, staticRenderFns } from "./OrgUserManage.vue?vue&type=template&id=36d87aff&"
import script from "./OrgUserManage.vue?vue&type=script&lang=js&"
export * from "./OrgUserManage.vue?vue&type=script&lang=js&"
import style0 from "./OrgUserManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports